type FeatureGroup = 'BOTH' | 'ASSESS' | 'PROTECT'

export interface GroupedRule {
  value: string
  name: string
  group?: FeatureGroup
  isAllOption?: boolean
}

export const ruleGroupI18n: Record<FeatureGroup, string> = {
  BOTH: 'title_featureTypeAssessAndProtect',
  ASSESS: 'title_featureTypeAssess',
  PROTECT: 'title_featureTypeProtect'
}
